import { isMeetingConfirmed } from 'common-data-handling';
import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import styles from './MeetingContextTitle.module.scss';
import { isMeetingCreatedByUser } from '../../../../../data/filters/meetings/isMeetingCreatedByUser';

function MeetingContextTitle(props) {
    const { className = '', meeting } = props,
        i18n = useI18n(),
        selfUserId = useMyUserId();

    let title;
    if (isMeetingConfirmed(meeting)) {
        title = i18n['meeting.title.confirmed'];
    } else if (isMeetingCreatedByUser(selfUserId, meeting)) {
        title = i18n['meeting.title.sent'];
    } else {
        title = i18n['meeting.title.request'];
    }

    return <h1 className={[className, styles.MeetingContextTitle].join(' ')}>{title}</h1>;
}

export default MeetingContextTitle;
